module.exports = __webpack_public_path__ + "img/no-data.c5d9a6c6.png";